export interface TaxonPackReducerState {
  loading: boolean
  items?: any[]
  error?: any
}

export const initialProductsState: TaxonPackReducerState = { loading: false }

const taxonPacksReducer = (
  state = initialProductsState,
  action: any
): TaxonPackReducerState => {
  switch (action.type) {
    case 'GET_PACKS_TAXONS_REQUEST':
      return { ...state, loading: true }
    case 'GET_PACKS_TAXONS_SUCCESS':
      return { ...state, loading: false, items: action.taxonPack }
    case 'GET_PACKS_TAXONS_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}

export default taxonPacksReducer
